import { HorizontalSafeAreaContainer } from '../../../components';
import { ForgotToScanScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <HorizontalSafeAreaContainer>
      <ForgotToScanScreen />
    </HorizontalSafeAreaContainer>
  );
}
